/**
 * Accessible (WCAG 2.2 AA) overrides for theme variables.
 *
 * These are spread on top of the base variables when high-contrast mode
 * is active. Only properties whose base values fail the 4.5:1 contrast
 * ratio are overridden here.
 *
 * Maps variable keys (from variables.js) to the accessible colors
 * defined in b4b-theme-a11y.js.
 */
import a11y from './b4b-theme-a11y';

export default {
  // Entrepreneur
  entColor: a11y.memberGreen,
  entColorHover: a11y.memberGreenHover,
  entColorFade: a11y.memberGreenFade,
  entColorBgFade: a11y.memberGreenBgFade,

  // Mentor
  mentorColor: a11y.mentorBlue,
  mentorColorHover: a11y.mentorBlueHover,
  mentorColorFade: a11y.mentorBlueFade,
  mentorColorBgFade: a11y.mentorBlueBgFade,

  // Grey
  greyColor: a11y.grey,
  placeholderGrey: a11y.placeholderGrey,
  lightOrange: a11y.lightOrange,
  hyperlinkBgFade: a11y.hyperlinkBgFade,
  lightYellowBgFade: a11y.lightYellowBgFade,

  // Links
  linkColor: a11y.hyperlink,
  linkHoverColor: a11y.hyperlink,

  // Program tag colors
  followUpColor: a11y.followUpColor,
  followUpColorBg: a11y.followUpColorBg,
  lightbrown: a11y.lightbrown,

  // Parrot
  parrotColor: a11y.parrotPink,
  parrotColorHover: a11y.parrotPinkHover,
  parrotColorFade: a11y.parrotPinkFade,
  parrotColorBgFade: a11y.parrotPinkBgFade,

  // Error
  labelRequiredColor: a11y.error,
  errorColor: a11y.error,
  errorColorFade: a11y.errorFade,
  errorColorHover: a11y.errorHover,
};
